export type DomainId = "llvm" | "k8s" | "ebpf" | "embedded" | "sre" | "ai-vibe" | "other";

export interface Domain {
  id: DomainId;
  label: string;
  tag: string;
}

export const domains: Domain[] = [
  { id: "llvm", label: "LLVM / Compiler", tag: "Passes, IR, clangd" },
  { id: "k8s", label: "Kubernetes / Platform", tag: "Operators, CRDs, RBAC" },
  { id: "ebpf", label: "eBPF / Systems", tag: "Verifier, XDP, bpftool" },
  { id: "embedded", label: "Embedded / Firmware", tag: "QEMU, GDB, RTOS" },
  { id: "sre", label: "SRE / Incident Response", tag: "Grafana, Loki, kubectl" },
  { id: "ai-vibe", label: "AI-assisted / Vibe coding", tag: "Copilot, agents, HMR" },
  { id: "other", label: "Other", tag: "Tell us what you interview for" },
];
